import {syncRegistry} from '../content/parties';
import {AX} from '../content/axes';
import {AX3} from '../content/axes3';
import {PRESETS} from '../content/settings';
import {initStates} from '../content/states';
import {seedRng} from './rng';
import {RULES} from './version';
import {newAdm} from './adm';
import {newCom} from './com';
import type {GameState,Positions} from './types';
export type {GameState} from './types';

export let S:GameState=null as unknown as GameState;
export function setS(s:GameState){
  S=s;
  // Parteien, die nur in dieser Partie existieren (eigene Partei eines Mitspielers), aus dem Zustand eintragen.
  syncRegistry(s&&s.mp);
}
export function fresh(seed:number=Math.floor(Math.random()*2**31),ver:number=RULES):GameState{seedRng(seed);const START:Positions={sozial:1,haushalt:1,sicherheit:1};return{seed,ver,phase:'program',name:'Aufbruch',you:Object.fromEntries([...AX,...AX3].map((a:string)=>[a,START[a]||0])),
  res:null!,partners:[],agree:null,fin:'YOU',m:0,issues:{},laws:[],nid:1,bonus:{rent:0,fam:0,arb:0,unt:0,jung:0},mood:{},
  lawB:0,lawGr:0,lawAl:0,infl:2.1,zins:2.1,drate:2,demoCost:0,demoCut:0,shockInfl:0,lob:{gew:50,arbg:50,soz:50,umw:50},lobCD:{},wing:{soz:60,wirt:60},suits:[],crisis:null,crisisHist:[],ptag:null,ptagLeg:-1,cfg:{diff:'normal',...PRESETS.normal},showCfg:false,memberFail:null,etat:{},ein:0,budget:null,budgets:[],court:null,ress:{},min:null!,scandal:null,pickFor:null,linger:null,promises:[],camp:null,lastCamp:null,tab:'lage',leg:0,m0:0,career:[],elYear:2029,legYear:2029,mapMode:'mood',selState:null,lastVote:null,toast:null,...initStates(),ind:{},ind0:{},hist:{},shockGr:0,shockB:0,saldo:-18,debt:2950,gr:.6,al:6.2,coal:70,basis:0,log:[],news:[],press:0,oppBill:null,editing:null,end:null,elec:0,final:0,scandalsLeg:0,prev:null,mp:null,confirmNew:false,...(ver>=4?{adm:newAdm()}:{}),...(ver>=5?{com:newCom()}:{})}}
let onSave:(()=>void)|null=null;
export function onSaveHook(fn:()=>void){onSave=fn}
export function save(){if(onSave)onSave()}
export function log(t:string,k:string=''){S.log.unshift({m:S.m,t,k});if(S.log.length>80)S.log.pop()}
